import axios from 'axios';
import jwtInterceptor from './jwtInterceptor';

/**
 * Byte grezzi di un allegato dal backend statistiche: `GET …/uploads/{id}`.
 *
 * È lo stesso percorso "che funziona": la pagina pubblica del task condiviso
 * serve gli stessi byte dalla stessa colonna (`uploads.blob`) già decodificati,
 * quindi niente base64 dentro un JSON gigante e niente risposte che si troncano
 * sui file grandi. Qui si scaricano grezzi (`arraybuffer`) e si rendono come fa
 * il browser.
 *
 * Niente `errorInterceptor`: un 404 (allegato non tuo) non deve far scattare il
 * logout globale; il chiamante ricade sull'endpoint Delphi.
 */
const instance = axios.create({
    baseURL: `${process.env.REACT_APP_STATS_BACKEND_BASE_URI}/uploads`,
    responseType: 'arraybuffer',
});

instance.interceptors.request.use(jwtInterceptor);

export default instance;
